export default {
    driver_performance_cases_title: "Rendimiento del Conductor - Casos",
    driver_performance_cases_caseId: "ID de Caso",
    driver_performance_cases_created: "Creado",
    driver_performance_cases_completed: "Completado",
    driver_performance_cases_eventCount: "Cantidad de Eventos",
    driver_performance_cases_driver: "Conductor",
    driver_performance_cases_coach: "Supervisor",
    driver_performance_cases_asset: "Activo",
    driver_performance_cases_status: "Estado",
    driver_performance_cases_tag: "Etiqueta",
    driver_performance_cases_tags: "Etiquetas",
    driver_performance_cases_custom: "Personalizado",
    driver_performance_cases_today: "Hoy",
    driver_performance_cases_yesterday: "Ayer",
    driver_performance_cases_week: "Esta Semana",
    driver_performance_cases_lastWeek: "Semana Pasada",
    driver_performance_cases_thisMonth: "Este Mes",
    driver_performance_cases_lastMonth: "Mes Pasado",
    driver_performance_cases_quarter: "Este Trimestre",
    driver_performance_cases_lastQuarter: "Trimestre Pasado",
    driver_performance_cases_assignCoach: "Reasignar Supervisor",
    driver_performance_cases_nextStep: "Próximo Paso / Resultado",
    dashboard_view: "Ver",
    driver_performance_cases_minutes : "Minutos",
    driver_performance_cases_noMoreItems: "No hay más casos de entrenamiento pendientes.",
    driver_performance_cases_status_pending: "Pendiente",
    driver_performance_cases_status_evaluate: "Evaluar",
    driver_performance_cases_status_completed: "Completado",
    driver_performance_cases_step_AssignCoach: 'Asignar Supervisor',
    driver_performance_cases_step_InitiateCoaching: "Iniciar Supervisión",
    driver_performance_cases_step_Monitor: "Monitorear",
    driver_performance_cases_step_PIOmited: "PI Omitido",
    driver_performance_cases_step_PISuccessfull: "PI Exitoso",
    driver_performance_cases_step_Judgement: "Evaluación",
    driver_performance_cases_step_PIFailed: "PI Fallido",
    driver_performance_cases_searchInput: "Buscar por ID del Caso",
    driver_performance_cases_coachUpdated: "Supervisor fue actualizado correctamente",
    driver_performance_cases_status_expired: "Expirado",
    driver_performance_cases_step_Expired: "Expirado",
};
